export const strengthVsWaterCementRatio: Record<string, number> = {
  "0.40": 5464,
  "0.41": 5314,
  "0.42": 5164,
  "0.43": 5014,
  "0.44": 4864,
  "0.45": 4714,
  "0.46": 4564,
  "0.47": 4414,
  "0.48": 4264,
  "0.49": 4114,
  "0.50": 3964,
  "0.51": 3868,
  "0.52": 3771,
  "0.53": 3675,
  "0.54": 3579,
  "0.55": 3482,
  "0.56": 3386,
  "0.57": 3289,
  "0.58": 3193,
  "0.59": 3096,
  "0.60": 3000,
  "0.61": 2936,
  "0.62": 2871,
  "0.63": 2807,
  "0.64": 2743,
  "0.65": 2679,
  "0.66": 2614,
  "0.67": 2550,
  "0.68": 2486,
  "0.69": 2421,
  "0.70": 2357,
  "0.71": 2304,
  "0.72": 2250,
  "0.73": 2196,
  "0.74": 2143,
  "0.75": 2089,
  "0.76": 2036,
  "0.77": 1982,
  "0.78": 1929,
  "0.79": 1875,
  "0.80": 1821,
  "0.81": 1779,
  "0.82": 1736,
  "0.83": 1693,
  "0.84": 1650,
  "0.85": 1607,
  "0.86": 1564,
  "0.87": 1521,
  "0.88": 1479,
  "0.89": 1436,
  "0.90": 1393,
  "0.91": 1356,
  "0.92": 1318,
  "0.93": 1281,
  "0.94": 1243,
  "0.95": 1205,
  "0.96": 1168,
  "0.97": 1130,
  "0.98": 1093,
  "0.99": 1055,
  "1.00": 1018,
  "1.01": 991,
  "1.02": 964,
  "1.03": 937,
  "1.04": 911,
  "1.05": 884,
  "1.06": 857,
  "1.07": 830,
  "1.08": 804,
  "1.09": 777,
  "1.10": 750,
  "1.11": 723,
  "1.12": 696,
  "1.13": 670,
  "1.14": 643,
  "1.15": 616,
  "1.16": 589,
  "1.17": 563,
  "1.18": 536,
  "1.19": 509,
  "1.20": 482,
  "1.21": 461,
  "1.22": 439,
  "1.23": 418,
  "1.24": 396,
  "1.25": 375,
  "1.26": 353,
  "1.27": 332,
  "1.28": 311,
  "1.29": 289,
  "1.30": 268
};
